<!-- Defered to a future build.
<button class="btn btn-primary export-button" title="Create PDF" (click)="getPdf()">Create PDF</button>
-->
<div class="form-group px-3 mt-2" id="mapDataFormGroup" [formGroup]="printForm">

  <input type="checkbox" formControlName="borderCheckbox" class="titleCheckbox" id="mapTitleCheckbox"
    (change)="emitMapBorderEnable()">
    <label for="mapTitleCheckbox">
      Add Title
    </label>
    @if (printForm.get('borderCheckbox').value) {
      <div>
        <div class="form-group" id="mapTitleForm">
          <label>
            Map title:
          </label>
          <input type="text" class="form-control name-input" formControlName="mapTitle" id="mapTitleValue"
            (keyup)="emitMapTitle()">
          </div>
          <div class="form-group" id="mapSubTitleForm">
            <label>
              Map subtitle:
            </label>
            <input type="text" class="form-control name-input" formControlName="mapSubTitle" id="mapSubTitleValue"
              (keyup)="emitMapsubTitle()">
            </div>
          </div>
        }
        <br />

        <input type="checkbox" formControlName="legendCheckbox" class="legendCheckbox" id="mapLegendCheckbox"
          (change)="emitMapLegendEnable()">
          <label for="mapLegendCheckbox">
            Add Legend
          </label>
          @if (printForm.get('legendCheckbox').value) {
            <div>
              <div class="form-group" id="mapLegendForm">
                <label>
                  Legend Position:
                </label>
                <select class="form-select" formControlName="legendPosition" (change)="emitMapLegendPosition()">
                  <option value="topRight">Top Right</option>
                  <option value="topLeft">Top Left</option>
                  <option value="bottomLeft">Bottom Left</option>
                  <option value="bottomRight">Bottom Right</option>
                </select>
              </div>
            </div>
          }
          <div class="row mx-0 mt-2">
            <label>Paper Size: </label>
            <select class="form-select" formControlName="paperSize">
              <option value="Letter">Letter (8.5 x 11)</option>
              <option value="Legal">Legal (8.5 x 14)</option>
              <option value="LEDGER">Tabloid (11 x 17)</option>
            </select>
          </div>
          <div class="row mx-0 mt-3">
            <label>Print: </label>
            <div class="row mx-0 d-flex justify-content-between w-100 print-size p-0">
              <button class="btn btn-outline-primary export-button" title="Print in Portrait" (click)="printMap('portrait')">
                <i class="fal fa-rectangle-portrait"></i> Portrait
              </button>
              <button class="btn btn-outline-primary export-button" title="Print in Landscape" (click)="printMap('landscape')">
                <i class="fal fa-rectangle-landscape"></i> Landscape
              </button>
              <button class="btn btn-outline-primary export-button" title="Specify Print Area" (click)="printMap('custom')">
                <i class="fal fa-draw-square"></i> Area
              </button>
            </div>
          </div>

        </div>